/** "Anna Schmidt", or the email when the name is empty. */
export const displayName = (user: { firstName?: string | null; lastName?: string | null; email: string }) =>
    [user.firstName, user.lastName].filter(Boolean).join(' ') || user.email;
